import React from "react";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import ViewTitle from "@components/Microsite/ViewTitle";
import { VinSetup } from "@components/RideChallenge";
import RideChallengeHeader from "./RideChallengeHeader";

import useAppStore from "@components/Microsite/microsite-store";

export default function VehicleView() {
  const { t } = useTranslation();
  const {
    vehicleInfo,
    setActiveStep,
    coords,
    setVehicleInfo,
    registrationInfo,
    verificationCode,
    location,
    user,
    entityInfo,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      location: state.location,
      registrationInfo: state.registrationInfo,
      vehicleInfo: state.vehicleInfo,
      user: state.user,
      verificationCode: state.verificationCode,
      setActiveStep: state.setActiveStep,
      setVehicleInfo: state.setVehicleInfo,
      entityInfo: state.entityInfo,
    }),
    shallow
  );

  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  return (
    <div>
      <RideChallengeHeader />
      <ViewTitle
        title={t("microsite:vehicle_view_title")}
        subtitle={t("microsite:vehicle_view_subtitle")}
      />
      <VinSetup
        verificationCode={verificationCode}
        onSuccess={() => {
          setActiveStep("vehicle_verification");
        }}
        additionalReqData={{
          ...coords,
          campaign_effort_id: entityInfo.campaign_effort_id,
          location_id: location?.id,
          user_interaction_id: registrationInfo?.initial_user_interaction_id,
          user_id: user?.id,
          user_location_id: user?.user_location_id,
        }}
        isVehicleDataEffort={isVehicleDataEffort}
      />
    </div>
  );
}
